<template lang="html">
  <div class="logo-wrap bg-white p-3 pb-1">
    <img src="@/assets/logos_header.svg" alt="Diensten Centrum" class="w-100" />
  </div>
  <div class="card-container">
    <h1 class="title">Jouw code is:</h1>
    <h1 class="code text-secondary">{{ getSavedCode }}</h1>
  </div>
</template>

<script>
export default {
  name: "CodeScreen",
  data: () => ({
    firstName: null,
    lastName: null,
    email: null,
  }),
  computed: {
    getSavedCode() {
      return this.$store.getters.getCode;
    },
  },
  methods: {},
};
</script>

<style lang="css" scoped>
.logo-wrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: rgba(40, 110, 187, 0.9);
  z-index: 10;
}

.logo-wrap img {
  display: block;
}

.card-container {
  background-color: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  margin: 20px auto;
}

.title {
  padding-bottom: 10px;
  font-size: 30px;
  font-weight: bold;
  color: #1c63af;
}
.code {
  font-size: 50px;
  padding-bottom: 0px;
}
</style>
